import type { IChangeLogFields } from './model/changeLog'
import Net from '@/services/net'
import utils from '@/services/utils'

export function getChangeLogFields() {
  return Net.t1.get<IChangeLogFields>(`/organizations/changelogfields`)
}

export function getChangeLogs(organizationId: number, requestObject: Record<string, any>, page?: number, pageSize?: number, cancelToken?) {
  const params = new URLSearchParams()
  if (utils.isDefined(page)) {
    params.set('page', page.toString())
  }
  if (utils.isDefined(pageSize)) {
    params.set('pageSize', pageSize.toString())
  }
  return Net.t1.post<any[]>(`/organizations/${organizationId}/changelogfields?${params.toString()}`, requestObject, { cancelToken })
}
